App.service('$fetch', (authServiceHelpers, SERVER_BASE_URL, $httpParamSerializerJQLike)  => {
  return ({ url, method='GET', headers={}, body, urlParams={}, signal, baseUrl = SERVER_BASE_URL, autoContentType = true }) => {
    const subdomain = authServiceHelpers.getUserSubdomain()
    const impersonationSessionId = authServiceHelpers.impersonationSessionId()
    const auth = authServiceHelpers.getUserAuthorizationHeader()
    const params = $httpParamSerializerJQLike(urlParams)

    let requestUrl = `${baseUrl}${url}?`
    if(subdomain) { requestUrl += `subdomain=${subdomain}&` }
    requestUrl += params

    body = body instanceof FormData ? body : JSON.stringify(body);

    const requestHeaders = Object.assign({
      'Accept': 'application/vnd.Nexhealth+json; version=1',
      'Authorization': auth,
      'If-None-Match': 's'
    }, headers)

    if(!requestHeaders['Content-Type'] && !(body instanceof FormData)){
      requestHeaders['Content-Type'] = 'application/json'
    }

    // TODO remove after ImpersonationSession retirement
    if (impersonationSessionId !== undefined) {
      headers['Nex-ImpersonationSessionId'] = impersonationSessionId
    }

    return fetch(requestUrl, {
      // signal allows cancellation using AbortControllers
      signal: signal,
      method: method,
      headers: requestHeaders,
      body: body
    })
  }
});
